<template>
    <v-app>
        <div class="md-layout">
            <div class="md-layout-item">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-green">
                        <div class="card-icon">
                            <md-icon>person_add</md-icon>
                        </div>
                        <h4 class="title">用户管理</h4>
                    </md-card-header>
                    <md-card-content>
                        <v-data-table :headers="headers" :items="userListData.userList" :sort-by="['currentSort', 'currentSortOrder']" :items-per-page="5" :sort-desc="[false, true]" multi-sort hide-default-footer class="paginated-table table-striped table-hover">
                            <template v-slot:top>
                                <v-row justify="space-between">
                                    <v-col class="d-flex" cols="6" sm="2">
                                        <v-select v-model="pagination.perPage" :items="pagination.perPageOptions" label="每页显示"></v-select>
                                    </v-col>
                                    <v-col class="d-flex" cols="6" sm="2">
                                        <v-text-field v-model="searchQuery" label="查找" type="search" class="mb-3" clearable style="width: 200px"></v-text-field>
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-slot:item.is_deleted="{ item }">{{ item.is_deleted ? '禁用' : '正常' }}</template>
                            <template v-slot:item.option="{ item }">
                                <div v-if="!item.is_deleted">
                                    <md-button class="md-just-icon md-success md-round md-simple" @click.native="handleEdit(item)">
                                        <md-icon>edit</md-icon>
                                    </md-button>
                                    <md-button class="md-just-icon md-danger md-round md-simple" style="margin-left:0px" @click.native="handleDelete(item)">
                                        <md-icon>unpublished</md-icon>
                                    </md-button>
                                </div>
                                <div v-else>
                                    <md-button class="md-just-icon md-success md-round md-simple" @click.native="handleRecover(item)">
                                        <md-icon>published_with_changes</md-icon>
                                    </md-button>
                                </div>
                            </template>
                        </v-data-table>
                    </md-card-content>
                    <md-card-actions md-alignment="space-between">
                        <div class="">
                            <p class="card-category">
                                {{ from + 1 }} 到 {{ to }} ，共 {{ userListData.count }}
                            </p>
                        </div>
                        <pagination class="pagination-no-border pagination-success" v-model="userListMap.page" :per-page="userListMap.pageSize" :total="userListData.count">
                        </pagination>
                    </md-card-actions>
                </md-card>
            </div>
        </div>
    </v-app>
</template>
<script>
import { Pagination } from "@/components";
import users from "../Tables/users";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import { userDelete, userRecover, userList } from '@/api/user';

export default {
    components: {
        Pagination,
    },
    computed: {
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.tableData;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0 ?
                this.searchedData.length :
                this.tableData.length;
        },
    },
    data() {
        return {
            loading: false,
            userListData: {
                count: 0,
                totle_page: 0,
                userList: []
            },

            headers: [{
                    text: '帐号',
                    align: 'center',
                    value: 'username',
                    filterable: true
                },
                { text: '姓名', align: 'center', value: 'name' },
                {
                    text: '状态',
                    value: 'is_deleted',
                    align: 'center'
                },
                { text: '编辑', align: 'center', value: 'option', width: "100px" }
            ],
            userListMap: {
                page: 1,
                pageSize: 5,
                perPageOptions: [5, 10, 25, 50],
                name: ''
            },
            currentSort: "name",
            currentSortOrder: "asc",
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0,
            },
            searchQuery: "",
            searchQueryTime: '',
            propsToSearch: ["account", "email", "mobile", "name", "company"],
            tableData: users,
            searchedData: [],
            fuseSearch: null,
            timer: null
        };
    },
    watch: {
        ['userListMap.pageSize']() {
            this.userListMap.page = 1;
            this.userList();
        },
        ['userListMap.page']() {
            this.userList();
        },
        searchQuery() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.userListMap.name = this.searchQuery;
                this.userListMap.page = 1;
                this.userList();
            }, 500);
        }
    },
    created() {
        this.userList();
    },
    methods: {
        userList() {
            this.loading = true;
            userList(this.userListMap).then((res) => {
                if (res.code === '200') {
                    this.userListData = res.data;
                    this.loading = false;
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        customSort(value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort;
                if (this.currentSortOrder === "desc") {
                    return a[sortBy].localeCompare(b[sortBy]);
                }
                return b[sortBy].localeCompare(a[sortBy]);
            });
        },
        handleEdit(item) {
            this.$router.push({ name: 'User', query: { uid: item.uid } });
        },
        handleDelete(item) {
            Swal.fire({
                title: "禁用信息",
                text: `请确认禁用用户信息！`,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "md-button md-success btn-fill",
                cancelButtonClass: "md-button md-danger btn-fill",
                confirmButtonText: "确 定",
                cancelButtonText: "取 消",
                buttonsStyling: false,
            }).then((result) => {
                console.log(result, 'resultresultresultresultresult', item);
                if (result.value) {
                    this.userDelete(item.uid);
                }
            });
        },
        handleRecover(item) {
            Swal.fire({
                title: "恢复信息",
                text: `请确认恢复用户信息！`,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "md-button md-success btn-fill",
                cancelButtonClass: "md-button md-danger btn-fill",
                confirmButtonText: "确 定",
                cancelButtonText: "取 消",
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.userRecover(item.uid);
                }
            });
        },
        userRecover(uid) {
            let that = this;
            let tempData = {
                uid: uid
            }
            userRecover(tempData).then((res) => {
                if (res.code === '200') {
                    this.userList();
                    this.$message.success('恢复成功');
                }
            })
        },
        userDelete(uid) {
            let that = this;
            let tempData = {
                uid: uid
            }
            userDelete(tempData).then((res) => {
                if (res.code === '200') {
                    that.userList();
                    that.$message.success('禁用成功');
                }
            })
        },
        deleteRow(item) {
            let indexToDelete = this.tableData.findIndex(
                (tableRow) => tableRow.id === item.id
            );
            if (indexToDelete >= 0) {
                this.tableData.splice(indexToDelete, 1);
            }
        },
    },
    mounted() {
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: ["name", "email"],
            threshold: 0.3,
        });
    }
};
</script>
<style lang="css" scoped>
.md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
}
</style>